import { selectWarehouse, updateWarehouse } from 'containers/Warehouses/warehousesSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { useHistory, useParams } from 'react-router-dom'
import React, { useState } from 'react'
import { Step } from '../core/utils'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'

const useResignationAction = (
  type: warehouse.ResignationType,
  selectedData: payments.SelectedData,
  delivery: payments.Delivery[],
  setStep: React.Dispatch<React.SetStateAction<Step>>
) => {
  const [isSending, setSending] = useState(false)
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))

  const { goBack } = useHistory()
  const dispatch = useReduxDispatch()
  const sendResignation = async () => {
    if (isSending) return
    setSending(true)
    try {
      const url = warehouse.resignation?.id
        ? `${urls.contractresignations}/${warehouse.resignation.id}`
        : urls.contractResignation(warehouse.contractId)
      const formData = new FormData()
      formData.append('date', selectedData.date)
      formData.append('type', type)
      if (selectedData.reasonId) {
        formData.append('reasonId', selectedData.reasonId)
      }
      if (selectedData.reason) {
        formData.append('reason', selectedData.reason)
      }
      if (selectedData.refundName) {
        formData.append('refundName', selectedData.refundName)
      }
      if (selectedData.refundAccountNumber) {
        formData.append('refundAccountNumber', selectedData.refundAccountNumber)
      }
      if (selectedData.photos) {
        selectedData.photos.forEach((photo, idx) => {
          formData.append(`photo[${idx}]`, photo)
        })
      }
      if (selectedData.itemsToReturn) {
        Object.entries(selectedData.itemsToReturn).forEach(([itemId, deliveryId]) => {
          formData.append(`itemsToReturn[${itemId}]`, deliveryId)
        })
        if (delivery) {
          const generateFormDataFromObject = (baseKey: string, object: Object) => {
            Object.entries(object).forEach(([key, value]) => {
              const currentKey = `${baseKey}[${key}]`
              if (typeof value === 'object') {
                generateFormDataFromObject(currentKey, value)
              } else {
                formData.append(currentKey, value)
              }
            })
          }
          delivery.forEach((delivery, idx) => {
            generateFormDataFromObject(`delivery[${idx}]`, delivery)
          })
        }
      }
      const response = await POST(url, { form: formData })
      if (response.data) {
        dispatch(updateWarehouse({ id, values: { resignation: response.data } }))
        if (response.data.canFinish) setStep('finish')
        else goBack()
      } else {
        throw new Error()
      }
    } catch (error) {
      setSending(false)
    }
  }

  return {
    isSending,
    sendResignation
  }
}

export default useResignationAction